<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.375 16.2L14.0417 12.8666C13.9337 12.7561 13.8135 12.6583 13.6833 12.575L12.85 12C13.6822 10.9702 14.1394 9.68801 14.1463 8.36403C14.1533 7.04006 13.7097 5.7531 12.8883 4.71465C12.067 3.67621 10.9168 2.94806 9.62684 2.64987C8.33686 2.35169 6.98382 2.5012 5.79007 3.07385C4.59633 3.6465 3.63289 4.6082 3.05811 5.80092C2.48333 6.99365 2.33139 8.34642 2.62727 9.63693C2.92314 10.9274 3.64923 12.0789 4.6862 12.9021C5.72317 13.7253 7.00934 14.1712 8.33332 14.1666C9.6567 14.167 10.9409 13.7174 11.975 12.8916L12.6 13.725C12.6741 13.8323 12.7578 13.9327 12.85 14.025L16.1833 17.3583C16.2221 17.3974 16.2681 17.4284 16.3189 17.4495C16.3697 17.4707 16.4242 17.4816 16.4792 17.4816C16.5342 17.4816 16.5886 17.4707 16.6394 17.4495C16.6902 17.4284 16.7363 17.3974 16.775 17.3583L17.3583 16.775C17.4345 16.6996 17.4787 16.5979 17.4818 16.4908C17.4849 16.3837 17.4467 16.2796 17.375 16.2ZM8.33332 12.5C7.50923 12.5 6.70365 12.2556 6.01845 11.7978C5.33324 11.3399 4.79919 10.6892 4.48383 9.92782C4.16846 9.16646 4.08595 8.32868 4.24672 7.52043C4.40749 6.71217 4.80433 5.96974 5.38704 5.38703C5.96976 4.80431 6.71219 4.40747 7.52045 4.2467C8.3287 4.08593 9.16648 4.16844 9.92784 4.48381C10.6892 4.79917 11.3399 5.33322 11.7978 6.01843C12.2556 6.70363 12.5 7.50921 12.5 8.3333C12.5 9.43837 12.061 10.4982 11.2796 11.2796C10.4982 12.061 9.43839 12.5 8.33332 12.5Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Search',
} as DefineComponent
</script>
